import { ApplicationRoutes } from '../../../app-routes-names'

export const FluidsRoutes = {
  summary: 'summary',
  list: 'list'
}

const { fluids } = ApplicationRoutes

export const FluidsPaths = {
  summary: `/${fluids}/${FluidsRoutes.summary}`,
  list: `/${fluids}/${FluidsRoutes.list}`
}
